import { render } from "./Node.vue?vue&type=template&id=2c3a94a1&scoped=true&ts=true"
import script from "./Node.vue?vue&type=script&lang=ts"
export * from "./Node.vue?vue&type=script&lang=ts"

import "./Node.vue?vue&type=style&index=0&id=2c3a94a1&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3a94a1"]])

export default __exports__